// Formatting helpers (Belgian locale, EUR). Month/weekday names follow the UI
// language: LanguageProvider calls setFormatLang() so every chart axis, date and
// KPI sub renders in NL or FR without threading `lang` through each call.
let LANG = 'nl';
export const setFormatLang = (l) => { LANG = l === 'fr' ? 'fr' : 'nl'; };
export const formatLang = () => LANG;

const eur = new Intl.NumberFormat('nl-BE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
const eur2 = new Intl.NumberFormat('nl-BE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 });
const num = new Intl.NumberFormat('nl-BE');

export const formatCurrency = (v) => eur.format(Number(v || 0));
export const formatCurrency2 = (v) => eur2.format(Number(v || 0));
export const formatNumber = (v) => num.format(Number(v || 0));
export const formatPct = (v, d = 1) => `${Number(v || 0).toFixed(d)}%`;

const MONTHS = {
  nl: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
  fr: ['janv', 'févr', 'mars', 'avr', 'mai', 'juin', 'juil', 'août', 'sept', 'oct', 'nov', 'déc'],
};
const MONTHS_LONG = {
  nl: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
  fr: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
};

// "2025-09" -> "sep '25" / "sept '25"
export const formatMonth = (ym) => {
  if (!ym) return '';
  const [y, m] = ym.split('-').map(Number);
  return `${MONTHS[LANG][m - 1]} '${String(y).slice(2)}`;
};
export const formatMonthLong = (ym) => {
  if (!ym) return '';
  const [y, m] = ym.split('-').map(Number);
  return `${MONTHS_LONG[LANG][m - 1]} ${y}`;
};

export const formatDate = (iso) => {
  if (!iso) return '';
  const [y, m, d] = iso.split('-').map(Number);
  return `${d} ${MONTHS[LANG][m - 1]} ${y}`;
};

// "2026-W23" -> "W23 '26" / "S23 '26"
export const formatWeek = (yw) => {
  if (!yw) return '';
  const [y, w] = yw.split('-W');
  return `${LANG === 'fr' ? 'S' : 'W'}${Number(w)} '${String(y).slice(2)}`;
};

// Backend payloads carry Dutch weekday names (`weekday_nl`); localise them here.
const WEEKDAYS_NL = ['Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag', 'Zondag'];
const WEEKDAYS_FR = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
const WEEKDAYS_EN = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
export const weekdayLabel = (name) => {
  if (!name) return '';
  const s = String(name);
  let i = WEEKDAYS_NL.findIndex((w) => s.toLowerCase().startsWith(w.toLowerCase()));
  if (i < 0) i = WEEKDAYS_EN.findIndex((w) => s.toLowerCase().startsWith(w.toLowerCase()));
  if (i < 0) return s;
  const base = LANG === 'fr' ? WEEKDAYS_FR[i] : WEEKDAYS_NL[i];
  // keep any suffix, e.g. "Zondag (uitzonderlijk open)" -> suffix handled by caller via t()
  return base;
};
// "ma" / "lun" style abbreviation
export const weekdayShort = (name) => {
  const l = weekdayLabel(name);
  return LANG === 'fr' ? l.slice(0, 3).toLowerCase() : l.slice(0, 2).toLowerCase();
};
// index 0..6 -> localized name
export const weekdayByIndex = (i) => (LANG === 'fr' ? WEEKDAYS_FR : WEEKDAYS_NL)[i] || '';
// "Donderdag" -> "donderdagen" / "jeudis" (for "the last 8 Thursdays")
export const weekdayPlural = (name) => {
  const l = weekdayLabel(name).toLowerCase();
  return l ? `${l}${LANG === 'fr' ? 's' : 'en'}` : '';
};

// Locale-aware full date/time for logs ("24/08/2026 15:03")
export const formatDateTime = (iso) => (iso ? new Date(iso).toLocaleString(LANG === 'fr' ? 'fr-BE' : 'nl-BE') : '—');
export const formatDateLocale = (iso) => (iso ? new Date(iso).toLocaleDateString(LANG === 'fr' ? 'fr-BE' : 'nl-BE') : '—');
